import { FuelCallout, FuelTypography } from '@frete.com/fuel-react';
import TextLink from 'components/ui/TextLink';
import { useRiskManagement } from 'hooks/useRiskManagement';
import { useTruckerProps } from 'hooks/useTruckerProps';
import React, { FC } from 'react';
import * as Styled from '../styled';

const RequiresUpdate: FC = () => {
  const { truckerId, freightId } = useTruckerProps();
  const { makeNavigateToRiskMagementURL } = useRiskManagement();

  return (
    <FuelCallout icon="alert" iconStyle="filled" fullWidth>
      <Styled.ContentWrapper slot="content" data-testid="gr-requires-update">
        <FuelTypography size="caption" weight="medium">
          O perfil desse motorista <strong>necessita de atualização</strong> na Gestão de Risco Fretebras.{' '}
          <TextLink label="Reenviar cadastro" link={makeNavigateToRiskMagementURL(truckerId, freightId)} />
        </FuelTypography>
      </Styled.ContentWrapper>
    </FuelCallout>
  );
};

export default RequiresUpdate;
